<template>
  <div class="noRow" v-if="dataValue.mailList.list.length === 0">还未添加任何邮件模板</div>
  <div class="youRow" v-if="dataValue.mailList.list.length > 0">
    <table class="ahuiTable">
      <tr>
        <th>模板标题</th>
        <th class="min">邮件标题</th>
        <th>邮件内容</th>
        <th class="min">创建时间</th>
        <th class="min">修改</th>
        <th class="min">删除</th>
      </tr>
      <tr v-for="aRow in dataValue.mailList.list">
        <td class="min" style="text-align: left;">{{ aRow['tempLabel'] }}</td>
        <td class="min" style="text-align: left;">{{ aRow['tempTitle'] }}</td>
        <td>{{ aRow['tempInfo'] }}</td>
        <td class="min">{{ aRow['createTime'] }}</td>
        <td class="min">
          <a @click="allEvent.mailAdd.modify(aRow)">修改</a>
        </td>
        <td class="min">
          <a-popconfirm title="请确认您要删除当前记录？" ok-text="是" cancel-text="否" @confirm="allHttp.mailDel(aRow)">
            <a>删除</a>
          </a-popconfirm>
        </td>
      </tr>
    </table>
  </div>
  <div style="text-align:center;">
    <a-button type="primary" @click="allEvent.mailAdd.openWindow">添加一个新的邮件模板</a-button>
  </div>


  <a-drawer
      :title="dataValue.addMail.title"
      width="950"
      :visible="dataValue.addMail.show"
      :maskClosable="false"
      :destroyOnClose="true"
      placement="right"
      @close="allEvent.mailAdd.closeWindow"
  >

    <mailAdd @goClose="allEvent.mailAdd.closeWindow2" :row="dataValue.addMail.row"/>
  </a-drawer>
</template>


<script>

import {reactive} from "vue";
import httpRequest from "@/utils/axios";
import {message} from "ant-design-vue";
import mailAdd from "@/view/set/template_mail_add"

export default {
  name : "template_mail",
  emits : [ 'setMenuKey' ],
  components : { mailAdd },
  setup(props, { emit }) {
    emit('setMenuKey', 'set.qxmbsz.mail');

    let dataValue = reactive({
      addMail : {
        title : "",
        show : false,
        row : null
      },
      mailList : {
        rowCount : 0,
        list : []
      }

    })

    let allHttp = {

      mailList : () => {

        httpRequest.post('/admin/set/ic7.template/list', { "typeId" : 2 })
            .then((res) => {
              if (res.code !== 200) {
                message.error(res.message);
              } else {
                dataValue.mailList.rowCount = res.data['rowCount'];
                dataValue.mailList.list = res.data['list'];
              }
            })

      },

      mailDel : (row) => {

        httpRequest.post('/admin/set/ic7.template/del', { "typeId" : 2, "tempId" : row['tempId'] })
            .then((res) => {
              if (res.code !== 200) {
                message.error(res.message);
              } else {
                allHttp.mailList();
                message.info('删除成功！')
              }
            })
      },

      init() {
        allHttp.mailList();
      }
    }

    allHttp.init();


    let allEvent = {

      mailAdd : {
        modify : (row) => {
          dataValue.addMail.show = true;
          dataValue.addMail.title = "修改邮件模板"
          dataValue.addMail.row = row;
        },

        openWindow : () => {
          dataValue.addMail.title = "添加一个新的邮件模板"
          dataValue.addMail.show = true;
          dataValue.addMail.row = null;
        },

        closeWindow : () => {
          dataValue.addMail.show = false;
        },

        closeWindow2 :()=>{
          allHttp.mailList();
          dataValue.addMail.show = false;
        }
      }

    }

    return {
      dataValue,
      allHttp,
      allEvent
    }
  }
}
</script>

<style scoped>
.noRow { margin: 30px; text-align: center; }
.youRow { padding: 15px; }
</style>